/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Await, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";

import { Box, Paper, Typography } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import ContainerDropdownMenu from "./searchOptionComponents/DropdownMenu";
import TabelContainers from "./TabelContainers";
import AnimatedNumbers from "react-animated-numbers";

import {
  deleteManageByIdRefrsh,
  setDeliveredByIdRefrsh,
} from "../../actions/mangeAction";
import {
  resetAddedDeleted,
  resetState,
  resetState as resetStateColor,
} from "../../slices/manageSlice";
import Progress from "../../components/Loader/Progress ";
import { initialShipmentForm } from "../../actions/formAction";
import { getCount } from "../../actions/getCountAction";
import { getMangeDataAction } from "../../actions/mangeActionV2";
import { resetGetManage } from "../../slices/manageSliceV2";

const ContainerList = () => {
  const mode = "container";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const reducer = useSelector((s) => s.manageV2.getManage) || {};
  const countReducer = useSelector((state) => state.fetchCount);
  const location = useLocation();
  const { accountType, loading, userInfo } = useSelector((state) => state.user);
  const currentClientId = userInfo?.client?.id;

  const [searchParams, setSearchParams] = useSearchParams();
  const dataGridPaperRef = useRef(null);


  const data = reducer.object || {};
  const content = data.content || [];


  // initial fetch + cleanup
  useEffect(() => {
    dispatch(getMangeDataAction({ mode, query: searchParams.toString() }));
    return () => {
      dispatch(resetStateColor());
      dispatch(resetAddedDeleted());
    };
  }, [mode, dispatch]);

  useEffect(() => {
    dispatch(initialShipmentForm());
    dispatch(getCount({ mode: "container" }));
  }, [dispatch]);

  // refetch on query change
  useEffect(() => {
    dispatch(getMangeDataAction({ mode, query: searchParams.toString() }));
  }, [
    searchParams.get("PageSize"),
    searchParams.get("PageNumber"),
    searchParams.get("SortOrder"),
    searchParams.get("SortBy"),
    searchParams.get("MixSearch"),
  ]);

  // URL query helpers
  const page = Number(searchParams.get("PageNumber")) || 0;
  const rowsPerPage = Number(searchParams.get("PageSize")) || 5;

  const setPage = (value) => {
    const next = new URLSearchParams(searchParams);
    next.set("PageNumber", String(value));
    setSearchParams(next);
  };
  const setRowsPerPage = (value) => {
    const next = new URLSearchParams(searchParams);
    next.set("PageSize", String(value));
    setSearchParams(next);
  };

  const handleChangePage = (_e, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handelFetchData = () =>
    dispatch(getMangeDataAction({ mode, query: searchParams.toString() }));

  const handleDeleteConfirm = (row) => {
    dispatch(
      deleteManageByIdRefrsh({
        mode,
        id: row?.id,
        query: searchParams.toString(),
      })
    );
  };

  useEffect(  () => {
    return async () => {
      await dispatch(resetGetManage());
    };
  }, [dispatch]);

  const handelEdit = (id) => {
    dispatch(resetState());
    navigate(
      `/container/addContainer?itemId=${id}&backLink=` +
        searchParams.toString().replaceAll("&", "*")
    );
  };

  const handleConfirmArrived = (row, value) => {
    dispatch(
      setDeliveredByIdRefrsh({
        mode,
        id: row?.id,
        deliveredDate: value,
        query: searchParams.toString(),
      })
    );
  };

  const handleCardClick = (name, id) => {

       const containerStatuses = [
        { enum: 'NOT_ARRIVED', label: 'Not Arrived', id:1 },
        { enum: 'ARRIVED', label: 'Arrived', id:2 },
        { enum: 'LOADED', label: 'Loaded', id:3 },
        { enum: 'DEPARTED', label: 'Departed', id:4 },
    ];




    const qs = new URLSearchParams(location.search);
    const pageSize = qs.get("PageSize");

    if (name === "status") {
      qs.set("Status", id);
      navigate(`/containers?Status=${containerStatuses.find(c => c.id === id)?.label}${pageSize ? "" : "&PageSize=5"}`);
    } else {
      navigate(
        `/containers?SearchOption=${id}${pageSize ? "" : "&PageSize=5"}`
      );
    }

    if (dataGridPaperRef.current) {
      dataGridPaperRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#F7F8FA",
        minHeight: "100vh",
        p: { xs: 0, md: 2 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          mb: 3,
          mt: { xs: 2, md: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 3,
            mt: { xs: 2, md: 0 },
          }}
        >
          <LocalShippingIcon sx={{ color: "#0B3C5D", fontSize: 36 }} />
          <Typography
            variant="h4"
            sx={{ color: "#0B3C5D", fontWeight: 800, letterSpacing: 1 }}
          >
            {t("Containers")}
          </Typography>
        </Box>
      </Box>

      <Paper
        sx={{
          p: { xs: 1, md: 3 },
          minHeight: 180,
          flexGrow: 1,
          background: "linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)",
          borderRadius: 4,
          boxShadow: "0 8px 32px 0 rgba(11, 60, 93, 0.10)",
          border: "1px solid #e9ecef",
          mb: 3,
        }}
      >
        {countReducer.loading === "pending" ||
        countReducer.loading === "idle" ? (
          <Progress />
        ) : (
          <Box>
            <Box
              sx={{
                display: "flex",
                mt: 2,
                justifyContent: "center",
                flexWrap: "wrap",
                gap: 3,
              }}
            >
              {countReducer.Object?.map((item, index) => {
                // ألوان الدائرة والخط حسب الفهرس
                const circleColor = [
                  "#0B3C5D",
                  "#D9B310",
                  "#1A5F8C",
                  "#A98A0C",
                  "#F3D351",
                  "#051E30",
                ][index % 6];
                const textColor =
                  index % 6 === 0 || index % 6 === 2 || index % 6 === 5
                    ? "#fff"
                    : "#0B3C5D";
                return (
                  <Box
                    key={index}
                    sx={{
                      width: 130,
                      height: 160,
                      borderRadius: 4,
                      background: "#fff",
                      boxShadow: "0 2px 8px 0 rgba(11, 60, 93, 0.08)",
                      border: "1px solid #e9ecef",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      position: "relative",
                      overflow: "hidden",
                      transition: "transform 0.18s, box-shadow 0.18s",
                      "&:hover": {
                        transform: "scale(1.06)",
                        boxShadow: "0 8px 24px 0 rgba(11, 60, 93, 0.16)",
                      },
                      cursor: "pointer",
                      p: 0,
                    }}
                    onClick={() => handleCardClick(item.type, item.id)}
                  >
                    {/* دائرة رقم الإحصائية */}
                    <Box
                      sx={{
                        width: 68,
                        height: 68,
                        borderRadius: "50%",
                        background: `linear-gradient(135deg, ${circleColor} 60%, #fff 100%)`,
                        boxShadow: "0 2px 8px 0 rgba(11, 60, 93, 0.10)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 2,
                        mb: 1.5,
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          color: textColor,
                          fontWeight: 800,
                          fontSize: 30,
                          textShadow:
                            textColor === "#fff"
                              ? "0 1px 4px #0B3C5D55"
                              : "none",
                        }}
                      >
                        <AnimatedNumbers
                          animateToNumber={item.count}
                          fontStyle={{ fontSize: 30 }}
                          configs={(number, index) => {
                            return {
                              mass: 1,
                              tension: 230 * (index + 1),
                              friction: 50,
                            };
                          }}
                        />
                      </Typography>
                    </Box>
                    {/* اسم الإحصائية */}
                    <Typography
                      sx={{
                        color: "#0B3C5D",
                        fontWeight: 700,
                        fontSize: 16,
                        textAlign: "center",
                        px: 1,
                        mb: 1,
                      }}
                    >
                      {item.name}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}
      </Paper>

      <Paper
        sx={{
          p: { xs: 1, md: 3 },
          minHeight: 200,
          flexGrow: 1,
          mt: 3,
          background: "#fff",
          borderRadius: 4,
          boxShadow: "0 8px 32px 0 rgba(11, 60, 93, 0.10)",
          border: "1px solid #e9ecef",
        }}
        ref={dataGridPaperRef}
      >
        <Box sx={{ mb: 2, width: "100%" }}>
          <ContainerDropdownMenu onFetchData={handelFetchData} isClient={accountType === 'client'} />
        </Box>

        {loading === "pending" || loading === "idle" || reducer.loading === "pending" || reducer.loading === "idle" ? (
          <Progress Msg="Loading ..." />
        ) : (
          <Box sx={{ width: "100%" }}>
            <TabelContainers
              data={content}
              total={data?.totalElements}
              page={page}
              rowsPerPage={rowsPerPage}
              accountType={accountType}
              currentClientId={currentClientId}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              onEdit={(id) => handelEdit(id)}
              onConfirmArrived={handleConfirmArrived}
              onConfirmDelete={handleDeleteConfirm}
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ContainerList;
